export default __webpack_public_path__ + "static/media/Tuesday_09.965ef766.png";